var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArkcFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 33,
    viewBox: "0 0 83 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30452_9249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3452 18.635H42.348L41.2037 21.4034H38.1406L43.897 8.48633H46.8485L52.6258 21.4034H49.486L48.3452 18.635ZM47.4049 16.3674L45.3571 11.4221L43.3074 16.3674H47.4049Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9134 11.6978C58.5558 11.4405 59.2432 11.3148 59.9351 11.328V13.9846C59.6141 13.9602 59.3996 13.948 59.2879 13.948C58.4646 13.948 57.8192 14.1806 57.3517 14.6457C56.8842 15.1109 56.6516 15.8028 56.6539 16.7215V21.4086H53.7705V11.4762H56.5214V12.7862C56.8737 12.2997 57.3562 11.9224 57.9134 11.6978Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9128 17.51L64.5296 18.8758V21.4034H61.6514V7.71191H64.5296V15.4621L68.737 11.4763H72.1699L68.0357 15.6889L72.5379 21.4087H69.0492L65.9128 17.51Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3515 20.8958C74.537 20.4855 73.8531 19.856 73.3769 19.0781C72.9119 18.2766 72.667 17.3664 72.667 16.4398C72.667 15.5131 72.9119 14.6029 73.3769 13.8014C73.8531 13.0236 74.537 12.3941 75.3515 11.9838C76.2364 11.5358 77.2172 11.3107 78.2088 11.3279C79.1636 11.3056 80.1079 11.5316 80.9492 11.9838C81.7114 12.3991 82.3121 13.0582 82.6552 13.8555L80.4224 15.0556C79.9061 14.1451 79.1618 13.6898 78.1896 13.6898C77.8452 13.6792 77.5022 13.7392 77.1818 13.8661C76.8614 13.993 76.5704 14.1841 76.3266 14.4277C75.8371 14.9196 75.5923 15.59 75.5923 16.4389C75.5923 17.2878 75.8382 17.9588 76.3301 18.4519C76.5739 18.6955 76.8649 18.8866 77.1853 19.0135C77.5057 19.1404 77.8487 19.2004 78.1931 19.1898C79.1769 19.1898 79.9212 18.7345 80.4259 17.8239L82.6587 19.045C82.3055 19.8291 81.7067 20.4769 80.9527 20.8905C80.1117 21.3474 79.1655 21.5754 78.2088 21.5516C77.2172 21.5689 76.2364 21.3437 75.3515 20.8958Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6092 0H10.4208C7.65705 0 5.00648 1.0979 3.05219 3.05219C1.09791 5.00647 0 7.65705 0 10.4208V21.6092C0 24.3729 1.09791 27.0235 3.05219 28.9778C5.00648 30.9321 7.65705 32.03 10.4208 32.03H21.6092C24.3729 32.03 27.0235 30.9321 28.9778 28.9778C30.9321 27.0235 32.03 24.3729 32.03 21.6092V10.4208C32.03 7.65705 30.9321 5.00647 28.9778 3.05219C27.0235 1.0979 24.3729 0 21.6092 0ZM9.57307 22.4657L11.621 17.5204L14.5183 20.4178L9.57307 22.4657ZM16.2435 21.5935L17.3826 18.8287L13.1438 14.5951L10.3772 15.7429L8.21246 13.5764L21.4173 8.51773L23.5105 10.611L18.4606 23.8298L16.2435 21.5935Z",
    fill: "#2F2F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30452_9249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.6497,
    height: 32.03,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkcFooter);
export default __webpack_public_path__ + "static/media/arkc-footer.94654e25fccfa61296744030d8b2bd29.svg";
export { ForwardRef as ReactComponent };